import React, { PropsWithChildren, CSSProperties, ReactNode } from 'react';
import { Stack, StackItem } from '@fluentui/react';
import SubSectionHeader from './SubSectionHeader';

type Props = {
    title: string | JSX.Element;
    id?: string | number;
    style?: CSSProperties;
    sectionBodyStyle?: CSSProperties;
    headerStyle?: CSSProperties;
    headingCenterContent?: ReactNode;
    headingEndContent?: ReactNode;
    labelStyle?: CSSProperties;
    preBodyContent?: ReactNode;
    footer?: ReactNode;
    isRequired?: boolean;
};

const SubSection = (props: PropsWithChildren<Props>): JSX.Element => {
    const sectionBodyStyle: React.CSSProperties = {
        paddingTop: 10,
        paddingBottom: 10,
        width: '100%',
        ...props.sectionBodyStyle,
    };

    return (
        <Stack
            className="section ms-motion-slideDownIn"
            id={props.id ? `'${props.id}` : ''}
            style={{ ...props.style }}
        >
            <SubSectionHeader
                title={props.title}
                headingCenterContent={props.headingCenterContent}
                headingEndContent={props.headingEndContent}
                headerStyle={props.headerStyle}
                labelStyle={props.labelStyle}
                isRequired={props.isRequired}
            />
            {props.preBodyContent || props.children || props.footer ? (
                <Stack
                    style={sectionBodyStyle}
                    tokens={{ childrenGap: 10 }}
                    className="section__body"
                >
                    {props.preBodyContent && <StackItem>{props.preBodyContent}</StackItem>}
                    <StackItem className="section__content" disableShrink>
                        {props.children}
                    </StackItem>
                    {props.footer && <StackItem>{props.footer}</StackItem>}
                </Stack>
            ) : null}
        </Stack>
    );
};

export default SubSection;
